//TODO MK - Remove this file (backwards compat)
export var assetsUrl = 'https://assets.asurion-ui.my.asurion53.com';
export var logosUrl = "".concat(assetsUrl, "/images/logos");
export var logos = {
    asurion: 'asurion-logo.svg',
    att: 'att-logo.svg',
    clarobr: 'claro-logo.svg',
    cox: 'cox-logo.svg',
    cricket: 'cricket-logo.svg',
    directv: 'directv-logo.svg',
    koodo: 'koodo-logo.svg',
    sprint: 'sprint-logo.svg',
    telcel: 'telcel-logo.svg',
    telus: 'telus-logo.svg',
    uscellular: 'uscellular-logo.svg',
    verizon: 'verizon-logo.svg'
};
export var getLogoSrc = function (src) {
    return src && logos[src]
        ? "".concat(logosUrl, "/").concat(logos[src])
        : "".concat(logosUrl, "/").concat(logos.asurion);
};
